import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { GenericResponse } from '@interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CampaignDetail, Campaign, DataDropdown, CampaignLevelsFees } from '../models/campaign.models';

@Injectable({
  providedIn: 'root'
})
export class CampaignsService {
  public campaigns = new BehaviorSubject<Campaign[]>(null);
  public products = new BehaviorSubject(null);

  constructor(private http: HttpClient, private config: ConfigService) { }

  public getCampaigns(): Observable<GenericResponse<Campaign[]>> {
    return this.http.get<GenericResponse<Campaign[]>>(this.config.getUrl('campanas.getCampanas')).pipe(
      tap((res: GenericResponse<Campaign[]>) => {
        this.campaigns.next(res.data);
      })
    );
  }

  public getCampaignDetail(idCampana: number | string): Observable<GenericResponse<CampaignDetail[]>> {
    return this.http.get<GenericResponse<CampaignDetail[]>>(
      this.config.getUrl('campanas.getDetallesCampana', { idCampana })
    );
  }

  public getCampaignLevels(codCrm: string): Observable<GenericResponse<CampaignLevelsFees>> {
    return this.http.get<GenericResponse<CampaignLevelsFees>>(
      this.config.getUrl('campanas.getNivelesCampana', { codCrm })
    );
  }

  public getProducts(params: any): Observable<GenericResponse> {
    return this.http.get<GenericResponse>(this.config.getUrl('campanas.maestros.getProducts'), { params }).pipe(
      tap((res: GenericResponse) => {
        this.products.next(res);
      })
    );
  }

  public getFees(params: any): Observable<GenericResponse<DataDropdown[]>> {
    return this.http.get<GenericResponse<DataDropdown[]>>(this.config.getUrl('campanas.maestros.getFees', { params }));
  }

  public getGeoZones(params: any): Observable<GenericResponse<DataDropdown[]>> {
    return this.http.get<GenericResponse<DataDropdown[]>>(this.config.getUrl('campanas.maestros.getGeoZones', { params }));
  }

  public setCampaign(params: any): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(this.config.getUrl('campanas.setCampana'), params).pipe(
      tap((res: GenericResponse) => {
        return res;
      })
    );
  }

  public getCampaingFile(value: any): Observable<any> {
    const { codCampaign, zona, nivel, margenTe, margenTp } = value;
    const params = {
      margenTe: margenTe ?? null,
      margenTp: margenTp ?? null,
    };
    if (!params.margenTe) {
      delete params.margenTe;
    }
    if (!params.margenTp) {
      delete params.margenTp;
    }
    return this.http.get(this.config.getUrl('campanas.getFile', { codCampaign, zona, nivel }), {
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
      params
    });
  }

  public getCampaingExcelFile(): Observable<any> {
    return this.http.get(this.config.getUrl('campanas.getExcelFile'), {
      headers: { Accept: 'application/xls' },
      responseType: 'blob',
      observe: 'response'
    });
  }
}
